import {
  SegmentedControl,
  SegmentedControlItem,
} from "@astryxdesign/core/SegmentedControl";
import { HStack, StackItem } from "@astryxdesign/core/Stack";
import { TextInput } from "@astryxdesign/core/TextInput";
import { CATEGORIES, type Category, type IdeaStatus } from "../../shared/types";
import { CATEGORY_META } from "../lib/format";
import { SearchIcon } from "../lib/icons";

interface Props {
  category: Category | "all";
  status: IdeaStatus;
  query: string;
  onCategory: (c: Category | "all") => void;
  onStatus: (s: IdeaStatus) => void;
  onQuery: (q: string) => void;
}

export function FilterBar({ category, status, query, onCategory, onStatus, onQuery }: Props) {
  return (
    <HStack gap={2} align="center" wrap="wrap">
      <SegmentedControl
        label="Category"
        size="sm"
        value={category}
        onChange={(v) => onCategory(v as Category | "all")}
      >
        <SegmentedControlItem value="all" label="All" />
        {CATEGORIES.map((c) => (
          <SegmentedControlItem key={c} value={c} label={CATEGORY_META[c].label} />
        ))}
      </SegmentedControl>
      <StackItem size="fill">
        <TextInput
          label="Search"
          isLabelHidden
          size="sm"
          placeholder="Search"
          startIcon={SearchIcon}
          hasClear
          value={query}
          onChange={onQuery}
        />
      </StackItem>
      <SegmentedControl
        label="Status"
        size="sm"
        value={status}
        onChange={(v) => onStatus(v as IdeaStatus)}
      >
        <SegmentedControlItem value="open" label="Open" />
        <SegmentedControlItem value="done" label="Done" />
      </SegmentedControl>
    </HStack>
  );
}
